module.exports = __webpack_public_path__ + "img/app-store.56f49574.svg";